import { render, staticRenderFns } from "./UserInfoCircle.vue?vue&type=template&id=6ecd657f"
import script from "./UserInfoCircle.vue?vue&type=script&lang=js"
export * from "./UserInfoCircle.vue?vue&type=script&lang=js"
import style0 from "./UserInfoCircle.vue?vue&type=style&index=0&id=6ecd657f&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports